<script>
import BaseRadio from '@/components/BaseRadio.vue';

export default {
  name: 'ProjectPublishTargetSelectorPopupWrappable',
  components: { BaseRadio },
  data() {
    return {
      publishTarget: null,
      title: null,
      hideSelf: false,
    };
  },
  computed: {
    departments() { return this.$store.getters['auth/companyDepartments']; },
  },
  methods: {
    init({ title, hideSelf }) {
      this.title = title;
      this.hideSelf = hideSelf;
    },
    save() {
      this.$emit('finish', this.publishTarget?.['@id'] ?? null);
    },
    cancel() {
      this.$emit('finish', false);
    },
  },
};
</script>

<template lang="pug">
  .b-publish-target-popup
    ._title(v-if="title") {{ title }}
    ._title(v-else) На каком аккаунте опубликовать проект?
    ._items
      label._radio-label(v-if="!hideSelf" @click="publishTarget = null")
        BaseRadio(:checked="publishTarget === null")
        ._radio-title На своем аккаунте
      label._radio-label(v-for="dept in departments" @click="publishTarget = dept")
        BaseRadio(:checked="publishTarget === dept")
        ._radio-title {{ dept.name }}, {{ dept.company }}
    Btn(green round @click="save") Продолжить
</template>

<style scoped lang="scss">
.publish-target-popup {
  &__title {
    margin-bottom: 20px;
    font-size: 24px;
  }

  &__items {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 20px;
  }
  &__radio-label {
    display: flex;
    gap: 15px;
    cursor: pointer;
  }
}
</style>
